import { DealStatusId, DealStatusResponse } from '@business/entities/deal';
import { Endpoint } from '@business/api/endpoint';

export interface DealStatusData {
  name?: string;
  status?: string | null;
}

export function fetchDealStatuses(withTrashed = false) {
  return Endpoint.get<DealStatusResponse[]>(`@gc/deal-statuses`, {
    params: withTrashed ? { withTrashed: 1 } : {},
  });
}

export function createDealStatus(data: DealStatusData) {
  return Endpoint.post<DealStatusResponse[]>(`@gc/deal-statuses`, {
    data: { name: data.name, status: data.status },
  });
}

export function updateDealStatus(id: DealStatusId, data: DealStatusData) {
  return Endpoint.patch<DealStatusResponse[]>(`@gc/deal-statuses/${id}`, {
    data: { name: data.name, status: data.status },
  });
}

export function deleteDealStatus(id: DealStatusId) {
  return Endpoint.delete<{ success: boolean }>(`@gc/deal-statuses/${id}`);
}

export function restoreDealStatus(id: DealStatusId) {
  return Endpoint.post<DealStatusResponse[]>(`@gc/deal-statuses/restore`, { data: { id } });
}

export function sortDealStatuses(ids: DealStatusId[]) {
  return Endpoint.post<DealStatusResponse[]>(`@gc/deal-statuses/sort`, { data: { ids } });
}
